/**
 * Simple hash function for TTS cache keys, implementing the djb2 hash function.
 * Works in both Node.js and browser environments.
 */
function getTTSHash(text) {
	let hash = 5381;
	for (let i = 0; i < text.length; i++) {
		hash = ((hash << 5) + hash) ^ text.charCodeAt(i);
	}
	return (hash >>> 0).toString(16);
}

module.exports = {getTTSHash};
